module.exports = __webpack_public_path__ + "img/ICONO17.3b40fd83.png";